// extracted by mini-css-extract-plugin
module.exports = {"DescriptionAndTags":"TjenesteDescriptionAndTagsAndImage_DescriptionAndTags__1qplz","Decription":"TjenesteDescriptionAndTagsAndImage_Decription__2zOHv"};